import React from 'react';

const SectionRecruitUnified = ({ event, setEvent }) => {
  return (
    <section id="recruit_unified">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-1 mt-4 d-inline-block">
          参加者
        </p>
        <p className="text-gray text-fz-small mt-0 mb-2">
          つなげーとに集客を一本化するとイベントページにその旨が表示されます。オン（つなげーとで全ての参加者を管理）にしているイベントを表示上で優遇します。
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="is_recruit_unified"
              checked={event.is_recruit_unified}
              onChange={(e) => {
                setEvent((prev) => ({
                  ...prev,
                  is_recruit_unified: e.target.checked,
                }));
              }}
            />
            <label
              className="custom-control-label"
              htmlFor="is_recruit_unified"
            >
              つなげーとの予約システム以外で、参加者を募集、または参加予定者がいない
            </label>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionRecruitUnified;
